import { Axios } from 'axios';
import { CONTROLLER_API_PREFIX, UNI_API_CONTROLLER } from 'app/constants';
import type { Contributor } from 'app/domain';

/**
 * A service class acts as a proxy, encapsulating the details of the underlying HTTP client
 * and exposing a consistent API for the application's data needs
 *
 * This class has a 1:1 relationship with the `ContributorController` from the NestAPI layer,
 */
class ContributorService {
  #httpClient: Axios;
  baseUrl: string;

  constructor(httpClient: Axios) {
    this.#httpClient = httpClient;
    this.baseUrl = `/${CONTROLLER_API_PREFIX}/${UNI_API_CONTROLLER.contributor}`;
  }

  async get(contributorName: string | undefined): Promise<Contributor> {
    // Temporary guard clause to handle empty contributor names
    // This will be removed as part of https://app.clickup.com/t/86b81rhhn
    // when contributor fetching is done at the page level
    if (!contributorName) {
      return {} as Contributor;
    }
    const response = await this.#httpClient.get(
      `${this.baseUrl}/${contributorName}`
    );
    return response.data;
  }
}

export default ContributorService;
